exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bg-darker[data-v-be328918] {\n  background-color: #e4e8eb;\n}\n", ""]);

// exports
